/* istanbul ignore file - need to fix flakey tests */
import { faTriangleExclamation } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Input } from '@partful/shared/ui/Input';
import { Typography } from '@partful/shared/ui/Typography';
import { useState } from 'react';
import styles from './EditPartsCategoriesCategoryNameInput.module.scss';

interface EditPartsCategoriesCategoryNameInputProps {
  error: string;
  onChange: (value: string) => void;
  initialCategoryName: string;
}

export function EditPartsCategoriesCategoryNameInput({
  error,
  onChange,
  initialCategoryName,
}: EditPartsCategoriesCategoryNameInputProps) {
  const [categoryName, setCategoryName] = useState(initialCategoryName);

  const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;

    setCategoryName(newValue);
    onChange(newValue);
  };

  return (
    <div className={styles.inputContainer}>
      <Input placeholder="Type a category name" value={categoryName} error={Boolean(error)} onChange={handleOnChange} />
      {error && (
        <Typography appearance="label" role="alert" className={styles.errorMessage}>
          <FontAwesomeIcon icon={faTriangleExclamation} /> {error}
        </Typography>
      )}
    </div>
  );
}
